<template>
  <div  id="app" :class="[curentPath=='th20'?'th20':'','app']">
    <header-component></header-component>
    <!-- <div id="trans"></div> -->
    <!-- <transition :name="transitionName"> -->
    <div :class="[$store.state.showRefound.show ? 'show-refound' : '']">
      <div
        id="main"
        :class="[
          $route.path.indexOf('/custom') > -1?'isActivityPage':'',
          $route.path.indexOf('/instore-registration') > -1
            ? 'instore-registration'
           : ''
          ,
          $route.path == '/shop-cart' || $route.path.indexOf('/account') > -1
            ? 'shop-cart'
            : '',
          'trans',
          showz ? 'showz' : '',
        ]"
      >
        <keep-alive>
          <router-view :key="$route.fullPath" v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view> 
      </div>
    </div>
    <floatbutton></floatbutton>
    <!-- </transition> -->
    <footer-component></footer-component>
    <loginPop v-if="$store.state.showLoginPop"></loginPop>
    <!-- <welcome-login-pop :welcomeLogin="$store.state.welcomeLogin" v-on:close="closeWelcomePop"></welcome-login-pop> -->
    <div v-show="showcookiepop">
        <cookie-set v-if="showPrivacy" v-on:closeBox="closePrivacyBox"></cookie-set>
    </div>
  
  </div>
</template>

<script>
import headerComponent from "./components/common/Header";
import footerComponent from "./components/common/Footer";
import loginPop from "./components/common/loginPop";
import WelcomeLoginPop from "./components/common/WelcomeLoginPop2";
import CookieSet from "./components/common/CookieSet";
import { isSupportWebp } from "./utils/utils";
import floatbutton from './components/common/FloatingButton';

export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
     
    
    };
  },

  watch: {
    "$route.path": function(newVal, oldVal) {
      this.checkCookie();
      var curentPath = this.$route.path;
      if(curentPath.indexOf('/20th-anniversary')>-1){
       this.curentPath='th20'
      }else{
        this.curentPath=''
      }
      if(curentPath.indexOf("instore-registration")>-1){
        this.showKefu=false;
        this.showcookiepop=false;
       
        // window.onload = function() {
        // var lastTouchEnd = 0;
        // document.addEventListener('touchstart', function(event) {
        //     if (event.touches.length > 1) {
        //         event.preventDefault();
        //     }
        // });
        // document.addEventListener('touchend', function(event) {
        //     var now = (new Date()).getTime();
        //     if (now - lastTouchEnd <= 300) {
        //         event.preventDefault();
        //     }
        //     lastTouchEnd = now;
        // }, false);
        // document.addEventListener('gesturestart', function(event) {
        //     event.preventDefault();
        // });
        // document.addEventListener('dblclick', function (event) {
        //     event.preventDefault();
        // })
        // };
       }else{
         this.showKefu=true;
         this.showcookiepop=true;
       }
      if (
        curentPath.indexOf("/sets") != -1 ||
        curentPath.indexOf("/custom") != -1
      ) {
      
        window.localStorage.setItem("LPLPath", curentPath);
      }
      this.setDeliveryRules();
      if (curentPath != "/") {
        document.getElementById("main").style.paddingTop = "";
      }
    }
  },

  data() {
    return {
      showz: false,
      isRouterAlive: true,
      showPrivacy: true,
      showKefu:true,
      curentPath:'',
      showcookiepop:false,
      transitionName: "fade",
      deliveryRule: {
        id: "",
        show: false,
        type: "",
        name: "",
        content: ""
      }
    };
  },
  created() {
    setTimeout(() => {
      this.showz = true;
    }, 500);
    if(this.$route.name=='home'){
      this.showcookiepop = true;
    };
    this.setDeliveryRules();
    this.getStoreDetail();
  },
  mounted() {
    // this.$nextTick(
    //   (function(w, d, n, a, j) {
    //     w[n] =
    //       w[n] ||
    //       function() {
    //         (w[n].a = w[n].a || []).push(arguments);
    //       };
    //     j = d.createElement("script");
    //     j.async = true;
    //     j.src = "https://qiyukf.com/script/03c0c639b60576ea26640ca95803cfb4.js";
    //     d.body.appendChild(j);
    //   })(window, document, "ysf")
    // )
    
    this.checkUser();
    this.$utils.countingDownVerifyCode(state => {});
    this.$utils.countingDownVerifyCode2(state => {});
    // 是否支持
    if (window.localStorage.getItem("isSupportWebp") == null) {
      isSupportWebp(this);
    }
    this.checkCookie();
    //浏览记录
    var curentPath = this.$route.path;
    if (
      curentPath.indexOf("/sets") != -1 ||
      curentPath.indexOf("/custom") != -1
    ) {
      window.localStorage.setItem("LPLPath", curentPath);
    }
  },
  methods: {
    checkUser() { 
      var that = this;
      var url = that.$store.state.API.my.getUserInfo;
      this.$http
        .get(url, {
          headers: { tb_token: window.localStorage.getItem("token") }
        })
        .then(res => {
          if (res.data.returnCode == "005" && !res.data.result) {
            //没有登录 或是失效
            window.localStorage.removeItem("userInfo");
            window.localStorage.removeItem("token");
            this.showMyAccount = false;
            let isExitlogin = !this.$store.state.isExitlogin;
            this.$store.commit("UpdateLoginStatus", isExitlogin);
            this.$store.commit("upDateLoveCount", 0);
            this.$store.commit("upDateShopCount", 0);
            // this.$store.commit("setValue", ["userLogin", true]);
             this.$store.commit("setValue", ["userLogin", false]);
          } else {
            this.$store.commit("setValue", ["userLogin", true]);
          }
        })
        .catch(err => {});
    },
    getStoreDetail: function() {
      let url = this.$store.state.API.common.getStoreDetail;
      let params = {
        store_id: this.$store.state.storeId
      };
      this.$http.post(url, this.$qs.stringify(params)).then(res => {
        var data = res.data.returnData;
        this.$store.commit("setValue", ["soldOut", data.soldOut]); //1 显示 0 隐藏
      });
    },
    closeWelcomePop() {
      
      this.$store.commit("setValue", ["welcomeLogin", false]);
    },
    closePrivacyBox() {
      this.showPrivacy = false;
    },
    checkCookie() {
      //COOKIE
      var set_cookie =
        this.getCookie("set_cookie") ||
        window.localStorage.getItem("set_cookie"); //cookie设置有时候会不见和有延时
      if (set_cookie) {
        this.showPrivacy = false;
      } else {
        this.showPrivacy = true;
      }
      // var welcomeLogin = window.localStorage.getItem("welcomeLogin");
      // var logined = window.localStorage.getItem("token") ? true : false;
      // if (logined) {
      //   this.$store.commit("setValue", ["welcomeLogin", false]);
      // } else {
      //   if (welcomeLogin) {
      //     this.$store.commit("setValue", ["welcomeLogin", false]);
      //   } else {
      //     setTimeout(() => {
      //       this.$store.commit("setValue", ["welcomeLogin", true]);
      //     }, 2000);
      //   }
      // }

      //
    },

    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    setDeliveryRules() {
      var that = this;
      var pathName = this.$route.name;
      if (pathName == "home") {
        // this.deliveryRule.show = true;
        this.deliveryRule.type = "home";
        this.deliveryRule.id = "4fc84982-a958-43f6-bddf-8426c747dede";
        this.getNoticeInfo();
      } else if (pathName == "sets") {
        // this.deliveryRule.show = true;
        this.deliveryRule.type = "sets";
        this.deliveryRule.id = "a2bc7003-9c55-4ebc-a3cd-0c859d6c8234";
        this.getNoticeInfo();
      } else if (pathName == "shopping") {
        // this.deliveryRule.show = true;
        this.deliveryRule.type = "shopping";
        this.deliveryRule.id = "477a6fde-a762-458e-a3d4-a7a28fd1daa3";
        this.getNoticeInfo();
      } else if (pathName == "shop-cart") {
        // this.deliveryRule.show = true;
        this.deliveryRule.type = "shop-cart";
        this.deliveryRule.id = "6ff8dcd9-1606-4d6a-9260-78e973511449";
        this.getNoticeInfo();
      } else if (pathName == "checkout") {
        // this.deliveryRule.show = true;
        this.deliveryRule.type = "checkout";
        this.deliveryRule.id = "5594282e-bcef-46e4-a05a-8cbeb9658266";
        this.getNoticeInfo();
      } else if (pathName == "custom") {
        // this.deliveryRule.show = true;
        this.deliveryRule.type = "custom";
        this.deliveryRule.id = "3bb473e6-1ba8-4d27-bb73-c4bc8f7154ad";
        this.getNoticeInfo();
      } else {
        this.deliveryRule.show = false;
        this.$store.commit("setValue", ["showRefound", false]);
      }
      // if (this.deliveryRule.show) {
      //   this.getNoticeInfo();
      // }
    },
    getNoticeInfo() {
      var that = this;
      let url =
        this.$store.state.API.sys.getNoticeInfo + "?id=" + that.deliveryRule.id;
      let paramsObj = {};
      this.$http.get(url, {}).then(res => {
        if (res.status == 200 && res.data.message == "success") {
          this.deliveryRule.show = res.data.returnData.status;
          this.deliveryRule.name = res.data.returnData.title;
          this.deliveryRule.content = res.data.returnData.textInformation;
          if (this.deliveryRule.show) {
            this.$store.commit("setValue", ["showRefound", this.deliveryRule]);
          }
        } else {
        }
      });
    },
    // 手机端
    setRem() {
      var whdef = 100 / 750; // 表示1920的设计图,使用100PX的默认值
      var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
      var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
      document.getElementsByTagName("html")[0].style.fontSize = rem + "px";
    },
    //pc端
    setRemPC() {
      var whdef = 100 / 1440; // 表示1920的设计图,使用100PX的默认值
      var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
      var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
      document.getElementsByTagName("html")[0].style.fontSize = rem + "px";
    },
    reload() {
  
      this.isRouterAlive = false;
      this.$nextTick(() => {
        // let _type = "zh";
        let _type = this.$store.state.store_name || "zh";
        if (
          (window.localStorage.getItem("localeLanguage") ||
            navigator.language) == "zh-CN"
        ) {
          if (this.$route.meta.title_zh) {
            document.title = this.$route.meta.title_zh(_type);
          }
        } else {
          if (this.$route.meta.title_en) {
            document.title = this.$route.meta.title_en(_type);
          }
        }
        this.isRouterAlive = true;
      });
    }
  },
  components: {
    headerComponent,
    footerComponent,
    loginPop,
    CookieSet,
    WelcomeLoginPop,
    floatbutton
  }
};
</script>

<style lang="less">
@blue: #1f88e5;
// #app {
//   font-family: "ArialNarrow,sans-serif";
//   // font-family: "ArialNarrow";
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   background-color: #ffffff;
//   color: #5c5d5f;
//   font-size: 12px;
//   text-align: center;
// }
.app{
  &.th20{
    background:#BFC1C3;
  }
}
#app {
  height: 100vh;
  min-height: 100%;
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;

  

}
.hiddenkefy .layer-7.hidden{
  display: none!important;
}
#main {
  // padding-top: 100px;
  // padding-top: 10rem;
  flex: 1 0 auto;
  padding-top: 6.6rem;
  min-height: calc(100vh - 6.6rem);

  &.shop-cart {
    min-height: 50vh;
  }
  &.instore-registration{
    padding-top:29px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.show-refound {
  // min-height: 50rem;
  margin-top: 3.5rem;
}
.trans {
  -webkit-font-smoothing: antialiased;
  outline: 0;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  -webkit-tap-highlight-color: transparent;
  &.showz {
    opacity: 1;
  }
}

@media screen and (max-width: 768px) {
  #YSF-BTN-HOLDER{
    display: none!important;;
  }
  #main {
    // padding-top: 100px;
    padding-top: 5rem;
    // min-height: calc(100vh - 8.4rem);
  }
  .isActivityPage{
    min-height: auto!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue